/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
 */
export interface GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum];


